import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Charts from "../Echarts";
import trianglezhu from "../../../utils/m4k/three/chsjzhzht";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      height: "30vh",
      fontSize: "3vw",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    subTitle: {
      fontSize: "2vw",
    },
  })
);

const TriLeft: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row">
      <Grid item xs={12}>
        <div className={classes.title}>
          <div>11507</div>
          <div className={classes.subTitle}>长三角化工网络供应商</div>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Charts
          option={trianglezhu}
          style={{
            height: "60vh",
            margin: "10px 0",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default TriLeft;
